import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AuthService} from './Services/auth.service';

// Import Containers
import { DefaultLayoutComponent } from './containers';
import { ChangePasswordComponent } from './views/change-password/change-password.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { LoginComponent } from './views/login/login.component';

import { ResetPasswordComponent } from './views/reset-password/reset-password.component';
import { AdminComponent } from './views/admin/admin.component';
import {MyprofileModule} from './views/student-profile/myprofile/myprofile.module';
import {TestpageModule } from './views/student-profile/test-page/test-page.module';
import { UserManagementComponent } from './views/user-management/user-management.component';
import { TestManagementComponent } from './views/test-management/test-management.component';
import { LogOfTestBalanceComponent } from './views/log-of-test-balance/log-of-test-balance.component';
import { LogOfWalletComponent } from './views/log-of-wallet/log-of-wallet.component';
import { AuthGuard } from './Services/auth.guard';
import { TermsConditionComponent } from './views/terms-condition/terms-condition.component';
import { PrivacyPolicyComponent } from './views/privacy-policy/privacy-policy.component';
import { RefundPolicyComponent } from './views/refund-policy/refund-policy.component';
import { ShippingPolicyComponent } from './views/shipping-policy/shipping-policy.component';
import { AboutComponent } from './views/about/about.component';
import { ContactComponent } from './views/contact/contact.component';
import { ImageSelectionQuestionComponent } from './views/image-selection-question/image-selection-question.component';
import { MoodLightTestingComponent } from './views/mood-light-testing/mood-light-testing.component';
import { MindTendencyTestComponent } from './views/mind-tendency-test/mind-tendency-test.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "changepassword",
    component: ChangePasswordComponent
  },
  {
    path: "reset-password",
    component: ResetPasswordComponent
  },


  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate : [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      
      {
        path:'trail-test',
        loadChildren: () => import('./views/trail-test/trail-test.module').then(m => m.TrailtestModule),
      },
      
      {
        path: 'myprofile',
        loadChildren: () => import('./views/student-profile/myprofile/myprofile.module').then(m => m.MyprofileModule),
        data: {
          title: 'myprofile'
        },
      },

      {
        path: 'mytest',
        loadChildren: () => import('./views/student-profile/test-page/test-page.module').then(m => m.TestpageModule),
        data: {
          title: 'My Test'
        },
      },
      {
        path: '',
        component: AdminComponent,
        canActivate : [AuthGuard],
        children:[
          {
            path: 'usermanagement',
            component: UserManagementComponent
          },
          {
            path: 'testmanagement',
            component: TestManagementComponent
          },
          {
            path: 'testlog',
            component: LogOfTestBalanceComponent
          },
          {
            path: 'topuplog',
            component: LogOfWalletComponent
          },
          {
            path: "image-selection",
            component: ImageSelectionQuestionComponent
          },
          {
            path: "mood-light-testing",
            component: MoodLightTestingComponent
          },
          {
            path: "mind-tendency-test",
            component: MindTendencyTestComponent
          }
        ]
      },

    ]
  },
  {
    path: "terms-n-conditions",
    component: TermsConditionComponent
  },
  {
    path: "privacy-policy",
    component: PrivacyPolicyComponent
  },
  {
    path: "refund-policy",
    component: RefundPolicyComponent
  },
  {
    path: "shipping-policy",
    component: ShippingPolicyComponent
  },
  {
    path: "about",
    component: AboutComponent
  },
  {
    path: "contact",
    component: ContactComponent
  },
 
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
